/* DesiTech cover finder v2: remember phone model & pastel across collection pages.
   If Shopify Search & Discovery exposes variant facets, use native URL filters.
   Otherwise preselect the model/colour on the individual product page. */
(function(){
  'use strict';
  var KEY='dtx_cover_preferences_v2';
  function read(){try{return JSON.parse(window.localStorage.getItem(KEY)||'{}')}catch(e){return {}}}
  function save(changes){try{window.localStorage.setItem(KEY,JSON.stringify(Object.assign({},read(),changes)))}catch(e){}}
  var finder=document.querySelector('[data-dtx-cover-finder]');
  if(finder){
    var model=finder.querySelector('[data-dtx-model]');
    var shades=Array.prototype.slice.call(finder.querySelectorAll('[data-dtx-shade]'));
    var hint=finder.querySelector('[data-dtx-hint]');
    var stored=read();
    if(model){
      var activeFacet=!!(model.dataset.filterParam && new URL(window.location.href).searchParams.get(model.dataset.filterParam));
      if(!activeFacet&&stored.model&&Array.prototype.some.call(model.options,function(o){return o.value===stored.model})){
        model.value=stored.model;
      }
      model.addEventListener('change',function(){
        save({model:model.value});
        var selected=model.selectedOptions[0];
        if(model.dataset.filterParam){var u=new URL(window.location.href);u.searchParams.delete(model.dataset.filterParam);u.searchParams.delete('page');if(selected&&selected.dataset.filterValue)u.searchParams.append(model.dataset.filterParam,selected.dataset.filterValue);window.location.assign(u.toString());return}
        if(hint)hint.textContent=model.value ? model.value+' saved ♡ Open a design to select the exact variant.' : 'Pick a design, then choose your phone model.';
      });
    }
    function setShade(button){
      shades.forEach(function(el){var yes=el===button;el.setAttribute('aria-pressed',String(yes));el.classList.toggle('is-active',yes)});
      if(button){save({shade:button.dataset.dtxShade});if(hint)hint.textContent=button.dataset.dtxShade+' saved ♡ You can change the colour on any product page.';}
    }
    var preselected=shades.find(function(b){return b.getAttribute('aria-pressed')==='true';})||shades.find(function(b){return b.dataset.dtxShade===stored.shade;});
    if(preselected)setShade(preselected);
    shades.forEach(function(button){button.addEventListener('click',function(){
      setShade(button);
      if(button.dataset.filterParam){var u=new URL(window.location.href);var key=button.dataset.filterParam;var currently=u.searchParams.getAll(key).indexOf(button.dataset.filterValue)!==-1;u.searchParams.delete(key);u.searchParams.delete('page');if(!currently)u.searchParams.append(key,button.dataset.filterValue);window.location.assign(u.toString());}
    })});
  }
  /* Product page. Do not override an explicit Shopify ?variant= selection. */
  if(!document.body.classList.contains('template-product'))return;
  if(!document.querySelector('.cc-picker-note'))return;
  if(new URLSearchParams(window.location.search).has('variant'))return;
  var preferences=read();
  if(!preferences.model&&!preferences.shade)return;
  var attempts=0;
  function prefill(){
    var picker=document.querySelector('.js-product desitech-variant-picker');
    if(!picker)return false;
    if(picker.dataset.dtxPrefilled==='true')return true;
    var matches=0;
    Array.prototype.forEach.call(picker.querySelectorAll(':scope > .option-selector'),function(field){
      var label=((field.querySelector('.label')||{}).textContent||'').toLowerCase();
      var chosen=/model|phone/.test(label)?preferences.model:/colou?r|shade|pastel/.test(label)?preferences.shade:null;
      if(!chosen)return;
      var cs=field.querySelector('custom-select');
      if(!cs||typeof cs.selectOption!=='function')return;
      var opt=Array.prototype.find.call(cs.querySelectorAll('.js-option[data-value]'),function(li){return (li.dataset.value||'').trim().toLowerCase()===chosen.trim().toLowerCase()});
      if(!opt)return;
      cs.selectOption(opt);
      matches++;
    });
    if(matches){picker.dataset.dtxPrefilled='true';picker.dispatchEvent(new Event('change',{bubbles:true}));return true;}
    return false;
  }
  function retry(){
    if(prefill())return;
    if(++attempts<8)window.setTimeout(retry,250);
  }
  if(customElements.get('custom-select'))window.setTimeout(retry,300);
  else customElements.whenDefined('custom-select').then(function(){window.setTimeout(retry,300)});
})();